import { Routes } from '@angular/router';
import { RandomGuard } from 'app/guards/random.guard';
import { HomeComponent } from 'app/home/home.component';
import { MyProfileComponent } from 'app/my-profile/my-profile.component';
import { TestComponent } from 'app/test/test.component';

export const AdminLayoutRoutes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },

    { path: 'home', component: HomeComponent, canActivate: [RandomGuard], canLoad: [RandomGuard] },
    { path: 'test', component: TestComponent,  canActivate: [RandomGuard], canLoad: [RandomGuard]},

    { path: 'my-account', component: MyProfileComponent, canActivate: [RandomGuard], canLoad: [RandomGuard] },
    {
        path: 'waybill',
        loadChildren: () => import('../../waybill/waybill.module').then(m => m.WaybillModule)
    },
    {
        path: 'trip',
        loadChildren: () => import('../../trip/trip.module').then(m => m.TripModule)
    },
    {
        path: 'commodities',
        loadChildren: () => import('../../commodities/commodities.module').then(m => m.CommoditiesModule)
    },
    {
        path: 'general',
        loadChildren: () => import('../../settings/settings.module').then(m => m.GeneralSettingsModule)
    },
    {
        path: 'staff',
        loadChildren: () => import('../../staff/staff.module').then(m => m.StaffModule)
    },
    {
        path: 'customer',
        loadChildren: () => import('../../customers/customers.module').then(m =>m.CustomersModule)
    },
    {
        path: 'finance',
        loadChildren: () => import('../../finance/finance.module').then(m =>m.FinanceModule)
    }
];
